// extracted by mini-css-extract-plugin
export default {"textCardList":"TextCardList_textCardList__IZAW1","textCard":"TextCardList_textCard__hSdS8"};